import {
  Page,
  Box,
  InlineStack,
  Text,
  Button,
  Icon,
  InlineGrid,
} from "@shopify/polaris";
import { AlertTriangleIcon } from "@shopify/polaris-icons";

import type { PropsWithChildren } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "./redux/hooks";
import { clearSessionTokenError } from "./app.slice";

interface IProps extends PropsWithChildren<unknown> {
  fromErrorBoundary?: boolean;
  clearError?: () => void;
}

const ErrorPage: React.FunctionComponent<IProps> = (props) => {
  const { fromErrorBoundary, clearError } = props;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleHomeLinkNav = async () => {
    if (fromErrorBoundary) {
      clearError?.();
    } else if (location.state?.hasSessionTokenError) {
      await dispatch(clearSessionTokenError());
    }

    navigate("/", { replace: true, state: null });
  };

  return (
    <Page>
      <Box paddingBlockStart="800">
        <InlineStack align="center">
          <Box>
            <InlineStack align="center">
              <InlineGrid alignItems="center" columns="2fr 9fr">
                <Icon source={AlertTriangleIcon} tone="critical" />

                <Text as="h1" variant="headingLg">
                  Something went wrong
                </Text>
              </InlineGrid>
            </InlineStack>

            <Box paddingBlockStart="400" paddingBlockEnd="800">
              <InlineStack align="center">
                <Text as="p" tone="subdued" alignment="center">
                  Unexpected error occurred OR The page you are looking for
                  doesn't exist.
                </Text>
              </InlineStack>
            </Box>

            <InlineStack align="center">
              <Button variant="primary" onClick={handleHomeLinkNav}>
                Go to Homepage
              </Button>
            </InlineStack>
          </Box>
        </InlineStack>
      </Box>
    </Page>
  );
};

export default ErrorPage;
